//
//
//
//
//
//
//

import StaticPage from '~/modules/storyblok/components/page-types/StaticPage.vue';
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'StaticPages',
  components: {
    StaticPage,
  },
  layout: 'basic',
  middleware: [
    'story-url-resolver',
  ],
  // eslint-disable-next-line @typescript-eslint/require-await
  async asyncData(context) {
    const localeSbUrl = context.$localeSbUrl;
    if (context.app.currentStory) {
      return { currentStory: context.app.currentStory, localeSbUrl };
    }
    return { currentStory: null, localeSbUrl };
  },
  head: {},
  watch: {
    '$i18n.locale': {
      handler(newLocale, oldLocale) {
        try {
          if (!oldLocale || !this.currentStory || !this.localePath || !this.$router) return;
          const localeSbUrl = this.$localeSbUrl || this.localeSbUrl;
          const slug = localeSbUrl({ slug: this.currentStory.default_full_slug });
          this.$nextTick(() => {
            this.$router.push(slug);
          });
        } catch (error) {
          console.error('Navigation failed:', error);
        }
      },
      immediate: true,
    },
  },
});
